// Importing necessary libraries and components
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import isEmpty from "lodash/isEmpty";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import MenuList from "@material-ui/core/MenuList";
import { withStyles } from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { format, parseISO } from "date-fns";
import SyntaxHighlighter from "react-syntax-highlighter";
import { DialogContent } from "@material-ui/core";
import Zoom from "@material-ui/core/Zoom";
import Fade from "@material-ui/core/Fade";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import VisibilityIcon from "@material-ui/icons//Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CryptoJS from "crypto-js"; // For encryption and decryption
import SyncIcon from "@material-ui/icons/Sync";
import AppLoader from "components/AppLoader/Index";

import noDataImage from "../../assets/img/noDataImage.png";
import ApiLogsSearchNew from "../../components/DialogBox/ApiLogsSearchNew";
import LongMenu from "../../components/Menu/JsonIndex";
import tableStyle from "../../assets/jss/material-dashboard-react/components/reportTables";
import {
  actionPermission,
  permissionCheck,
  groupCheck,
  getDefaultDateRange,
  getValidValue,
} from "../../Utils/commonUtils";
import { ReactComponent as ExportIcon } from "../../assets/svgIcons/ExportIcon.svg";
import SearchFields from "../../components/SearchComponent/SearchFields";
import SearchChips from "../../components/SearchComponent/SearchChips";
import {
  sendInviteApiCall,
  sendInviteManagerApiCall,
} from "../../actions/Operations";
import {
  getApiLogsDataFetchLogs,
  emptyReduxState,
  getApiLogsDataExportNew,
  getApiLogsDataJson,
  setFormDataApiLogs,
  clearFormDataApiLogs,
  getApiLogsByIdDataFetchLogs,
  getApiLogsByIdDataFetchLogsNew,
  getDecryptedApiLogsJsonDataACH
} from "../../Redux/Actions/merchantInformation";

// Tooltip styling for icons
const IconsTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#000",
    fontSize: "12px",
  },
  tooltipPlacementTop: {
    margin: "4px 0",
  },
}))(Tooltip);

// Code block styling for JSON display
const codeStyle = {
  backgroundColor: "#282c34",
  padding: "1em",
  borderRadius: "4px",
  fontFamily: "Menlo, monospace",
  fontSize: "14px",
};

// Custom styles for Material-UI components
const useStyles = makeStyles(tableStyle);

// Function to create a data object for table rows
function createData(
  _id,
  Type,
  Module_Name,
  Source,
  Request_Time,
  Response_Time,
  Requested_By,
  Requested_For,
  Request_JSON,
  Response_JSON,
  Status
) {
  return {
    _id,
    Type,
    Module_Name,
    Source,
    Request_Time,
    Response_Time,
    Requested_By,
    Requested_For,
    Request_JSON,
    Response_JSON,
    Status,
  };
}

// Array to store table rows
let rows = [];

// Component for custom table pagination actions
function TablePaginationActions(props) {
  const classes = useStyles();
  const theme = useTheme();

  const {
    count, page, rowsPerPage, onPageChange,
  } = props;

  // Handlers for pagination buttons
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.rootPagination}>
      {/* First Page Button */}
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        variant="body2"
        aria-label="first page"
      >
        {theme.direction === "rtl" ? (
          <Typography>Last</Typography>
        ) : (
          <Typography variant="body2">First</Typography>
        )}
      </IconButton>
      {/* Previous Page Button */}
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <Typography>Previous</Typography>
        ) : (
          <Typography variant="body2">Previous</Typography>
        )}
      </IconButton>
      {/* Current Page Indicator */}
      <IconButton
        onClick={handleFirstPageButtonClick}
        aria-label="first page"
        className={classes.bottonPage}
      >
        <Typography variant="body2">{page ? page + 1 : 1}</Typography>
      </IconButton>
      {/* Next Page Button */}
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <Typography variant="body2">Next</Typography>
        )}
      </IconButton>
      {/* Last Page Button */}
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? (
          <FirstPageIcon />
        ) : (
          <Typography variant="body2">Last</Typography>
        )}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

// Component for rendering the table header with sorting functionality
function EnhancedTableHead(props) {
  const {
    classes, order, orderBy, onRequestSort,
  } = props;

  // Handler for sorting columns
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  // Define table header cells
  const headCells = [
    {
      id: "Type_Name",
      numeric: false,
      disablePadding: true,
      label: "Api Type",
      headClassName: classes.DBA_Name,
    },
    // {
    //   id: "Module_Name",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Module",
    //   headClassName: classes.Assign_To,
    // },
    // {
    //   id: "Source",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Source",
    //   headClassName: classes.Assign_To,
    // },
    {
      id: "Request_Time",
      numeric: false,
      disablePadding: false,
      label: "Request (Eastern Time)",
      headClassName: classes.Assign_To,
    },
    {
      id: "Response_Time",
      numeric: true,
      disablePadding: false,
      label: "Response (Eastern Time)",
      headClassName: classes.email,
    },
    {
      id: "Requested_By",
      numeric: true,
      disablePadding: false,
      label: "Requested By",
      headClassName: classes.email,
    },
    {
      id: "Requested_For",
      numeric: true,
      disablePadding: false,
      label: "Requested For",
      headClassName: classes.email,
    },
    {
      id: "Status",
      numeric: true,
      disablePadding: false,
      label: "Status",
      headClassName: classes.Phone,
    },
    {
      id: "blank",
      numeric: false,
      disablePadding: false,
      label: "Action",
      headClassName: classes.status,
    },
  ];

  return (
    <TableHead className={classes.tableHeader}>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            className={classes.cellTextHeaderOffer}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

// Main component for rendering the API Logs report
const ProviderReport = (props) => {
  const pathParts = window.location.pathname.split("/");
  const idFromUrl = pathParts[pathParts.length - 1];
  const { startDate, endDate } = getDefaultDateRange(idFromUrl);
  const classes = useStyles();
  const [page, setPage] = React.useState(1);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("Request_Time");
  const [selected, setSelected] = React.useState([]);
  const [chipValue, setChipValue] = React.useState([]);
  const [searchDataFiled, setSearchDataFiled] = React.useState();
  const theme = useTheme();
  const [loading, setLoading] = React.useState(false);
  const windowWidth = useMediaQuery(theme.breakpoints.up("md"));
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [openImportFileModal, setImportFileModalOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [updateDBAModal, setUpdateDBAModal] = React.useState(false);
  const menu = JSON.parse(localStorage.getItem("menu"));
  const [searchBar, setSearchBar] = React.useState(false);
  const [requestJsonData, setRequestJsonData] = React.useState();
  const [requestJsonDataNew, setRequestJsonDataNew] = React.useState(null);

  const [responseJsonData, setResponseJsonData] = React.useState();
  const [apiType, setApiType] = React.useState(false)
  const [showDecData, setShowDecData] = React.useState(false)
  const copyToClipboardResponse = () => {
    navigator.clipboard.writeText(JSON.stringify(responseJsonData, null, 2));
  };
  const [requestReferenceId, setRequestReferenceId] = React.useState("")
  // const instance = new LogFetcherList();
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  // const queryParams = new URLSearchParams(window.location.search);
  // const idFromUrl = queryParams.get("group");

  const copyToClipboardRequest = () => {
    navigator.clipboard.writeText(JSON.stringify(showDecData ? requestJsonDataNew : requestJsonData, null, 2));
  };

  const handleToggle = () => {
    setImportFileModalOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    const chips = [];
    const formattedStartDate = format(parseISO(startDate), "MM/dd/yy");
    const formattedEndDate = format(parseISO(endDate), "MM/dd/yy");
    chips.push(`Date From: ${formattedStartDate} - To ${formattedEndDate}`);
    setChipValue(chips);
    const searchFilterData = localStorage.getItem(
      `filtered_search_${idFromUrl}`,
    );
    if (searchFilterData) {
      const data = JSON.parse(searchFilterData);
      setSearchDataFiled(data);
      displayAndDeleteChips(data);
      props.setFormDataApiLogs(data);
    } else {
      const updatedFormData = {
        pageNo: 1,
        pageSize: 5,
        searchRequestedFor: "",
        searchApiType: "",
        searchApiTypeValue: "",
        searchModule: "",
        searchModuleValue: "",
        groupName: idFromUrl,
        searchStatus: null,
        searchStartDate: startDate,
        searchEndDate: endDate,
        dateRange: true,
      };
      setSearchDataFiled(updatedFormData);
      props.setFormDataApiLogs(updatedFormData);
    }
  }, [idFromUrl]);

  const onClose = () => {
    setUpdateDBAModal(false);
    setApiType(false)
    setShowDecData(false)
    setRequestJsonDataNew(null)
  };
  const handleCloseModel = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setImportFileModalOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setImportFileModalOpen(false);
    }
  }

  React.useEffect(() => {
    if (
      props?.apiLogsDataFetchLogs?.apiLogsDataFetchLogs?.pagination
        ?.currentPage !== page
    ) {
      setPage(
        props?.apiLogsDataFetchLogs?.apiLogsDataFetchLogs?.pagination
          ?.currentPage
      );
    }
    if (
      props?.apiLogsDataFetchLogs?.apiLogsDataFetchLogs?.fetchedCount !==
      rowsPerPage
    ) {
      setRowsPerPage(
        props?.apiLogsDataFetchLogs?.apiLogsDataFetchLogs?.fetchedCount < 1
          ? 5
          : props?.apiLogsDataFetchLogs?.apiLogsDataFetchLogs?.fetchedCount
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  React.useEffect(
    () => () => {
      const searchFilterData = localStorage.getItem(
        `filtered_search_${idFromUrl}`,
      );
      if (searchFilterData) {
        const data = JSON.parse(searchFilterData);
        setSearchDataFiled(data);
        displayAndDeleteChips(data);
        props.setFormDataApiLogs(data);
      } else {
        const updatedFormData = {
          searchRequestedFor: "",
          searchApiType: "",
          searchModule: "",
          searchStartDate: "",
          searchEndDate: "",
          groupName: idFromUrl,
          searchStatus: "",
          sortColumn: orderBy,
          sortOrder: order,
          // dateRange: false,
        };
        props.setFormDataApiLogs(updatedFormData);
      }

      props.clearFormDataApiLogs();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [idFromUrl],
  );

  React.useEffect(() => {
    if(searchDataFiled){
      handleRefresh();
    }
  }, [searchDataFiled]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const payload = {
      Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
      pageNo: newPage + 1,
      groupName: idFromUrl,
      pageSize: rowsPerPage < 5 ? 5 : rowsPerPage,
      sortColumn: orderBy,
      sortOrder: order,
      exportToExcel: false,
      exportToPDF: false,
      searchRequestedFor: searchDataFiled?.searchRequestedFor ?? props?.apiLogsDataFetchLogs?.searchRequestedFor ?? "",
      searchApiType: searchDataFiled?.searchApiType ?? props?.apiLogsDataFetchLogs?.searchApiType ?? "",
      searchModule: searchDataFiled?.searchModule ?? props?.apiLogsDataFetchLogs?.searchModule ?? "",
      searchStatus: searchDataFiled?.searchStatus ?? props?.apiLogsDataFetchLogs?.searchStatus ?? "",
      searchStartDate: searchDataFiled?.searchStartDate ?? startDate ?? "",
      searchEndDate: props?.apiLogsDataFetchLogs?.dateRange ? searchDataFiled?.searchEndDate ?? endDate ?? "" : null,
      dateRange: props?.apiLogsDataFetchLogs?.dateRange,
    };
    localStorage.setItem(`filtered_search_${idFromUrl}`, JSON.stringify(payload))
    props.getApiLogsDataFetchLogs(payload);
  };

  const exportListData = () => {
    setLoading(true);

    const filterData = {
      Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
      pageNo: 1,
      pageSize:
        props.apiLogsDataFetchLogs.apiLogsDataFetchLogs?.pagination
          ?.totalRecordsAvailable,
      sortColumn: orderBy,
      sortOrder: order,
      exportToExcel: true,
      exportToPDF: false,
      groupName: idFromUrl,
      searchRequestedFor: searchDataFiled?.searchRequestedFor ?? props?.apiLogsDataFetchLogs?.searchRequestedFor ?? "",
      searchApiType: searchDataFiled?.searchApiType ?? props?.apiLogsDataFetchLogs?.searchApiType ?? "",
      searchModule: searchDataFiled?.searchModule ?? props?.apiLogsDataFetchLogs?.searchModule ?? "",
      searchStatus: searchDataFiled?.searchStatus ?? props?.apiLogsDataFetchLogs?.searchStatus ?? "",
      searchStartDate: getValidValue(
        searchDataFiled?.searchStartDate,
        startDate,
      ) ?? "",
      searchEndDate: getValidValue(
        searchDataFiled?.searchEndDate,
        endDate,
      ) ?? "",
    };

    props.getApiLogsDataExportNew(
      filterData,
      (data) => {
        // Success callback
        setLoading(false);
        if (data) {
          console.log("Download successful");
        }
      },
      (error) => {
        // Failure callback
        console.error("Error during export:", error);
        setLoading(false); // Stop loading even if an error occurs
      }
    );
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    const payload = {
      Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
      pageNo: 1,
      groupName: idFromUrl,
      pageSize: parseInt(event.target.value, 10),
      sortColumn: orderBy,
      sortOrder: order,
      exportToExcel: false,
      exportToPDF: false,
      searchRequestedFor: searchDataFiled?.searchRequestedFor ?? props?.apiLogsDataFetchLogs?.searchRequestedFor ?? "",
      searchApiType: searchDataFiled?.searchApiType ?? props?.apiLogsDataFetchLogs?.searchApiType ?? "",
      searchModule: searchDataFiled?.searchModule ?? props?.apiLogsDataFetchLogs?.searchModule ?? "",
      searchStatus: searchDataFiled?.searchStatus ?? props?.apiLogsDataFetchLogs?.searchStatus ?? "",
      searchStartDate: searchDataFiled?.searchStartDate ?? startDate ?? "",
      searchEndDate: props?.apiLogsDataFetchLogs?.dateRange ? searchDataFiled?.searchEndDate ?? endDate ?? "" : null,
      dateRange: props?.apiLogsDataFetchLogs?.dateRange,
    };
    localStorage.setItem(`filtered_search_${idFromUrl}`, JSON.stringify(payload))
    props.getApiLogsDataFetchLogs(payload);
  };

  const displayAndDeleteChips = (searchData) => {
    const chips = [];
    if (searchData.searchStatus) {
      chips.push(`Status: ${searchData.searchStatus}`);
    }
    if (searchData?.searchRequestedFor) {
      chips.push(`Requested For: ${searchData?.searchRequestedFor}`);
    }
    if (
      // handleBackPath === true
      // &&
      searchData?.searchStartDate &&
      !searchData?.searchEndDate
    ) {
      const formattedStartDate = format(
        new Date(searchData?.searchStartDate),
        "MM/dd/yy"
      );
      if (searchData?.dateRange === true) {
        chips.push(`Date From: ${formattedStartDate} - To End`);
      } else {
        chips.push(`Date: ${formattedStartDate}`);
      }
    }
    if (
      // handleBackPath === true
      // &&
      !searchData?.searchStartDate &&
      searchData?.searchEndDate
    ) {
      const formattedEndDate = format(
        new Date(searchData?.searchEndDate),
        "MM/dd/yy"
      );
      if (searchData?.dateRange === true) {
        chips.push(`Date From: Start - To ${formattedEndDate}`);
      } else {
        chips.push(`Date: ${formattedEndDate}`);
      }
    }
    if (
      // handleBackPath === true
      // &&
      searchData?.searchStartDate &&
      searchData?.searchEndDate
    ) {
      const formattedStartDate = format(
        new Date(searchData?.searchStartDate),
        "MM/dd/yy"
      );
      const formattedEndDate = format(
        new Date(searchData?.searchEndDate),
        "MM/dd/yy"
      );
      chips.push(`Date From: ${formattedStartDate} - To ${formattedEndDate}`);
    }

    // if (searchData.searchApiType) {
    //   let type = "";
    //   switch (searchData.searchApiType) {
    //     case "RTN API":
    //       type = "RTN API";
    //       break;
    //     case "Send Fund API":
    //       type = "Send Fund API";
    //       break;
    //     case "Send Fee API":
    //       type = "Send Fee API";
    //       break;
    //     case "Refund Fund API":
    //       type = "Refund Fund API";
    //       break;
    //     default:
    //       type = "";
    //   }
    //   if (type) {
    //     chips.push(`API Type: ${type}`);
    //   }
    // }
    if (searchData.searchApiType) {
      const allLookups = props.roles.lookupMasterData?.data || [];
      let moduleDisplayName = "";

      // Loop through groupCheck to find the correct group by matching Lookup_Code in lookupMasterData
      for (const groupKey in groupCheck) {
        const moduleCode = groupCheck[groupKey]?.APIType;
        const moduleLookup = allLookups.find(
          (lookup) => lookup.Lookup_Code === moduleCode
        );

        const matchedDetail = moduleLookup?.LookUp_Detail.find(
          (detail) => detail.Lookup_Detail_Code === searchData.searchApiType
        );

        if (matchedDetail) {
          moduleDisplayName = matchedDetail.Lookup_Detail_Name;
          break; // Stop looping once found
        }
      }

      if (moduleDisplayName) {
        chips.push(`API Type: ${moduleDisplayName}`);
      }
    }
    if (searchData.searchModule) {
      const allLookups = props.roles.lookupMasterData?.data || [];
      let moduleDisplayName = "";

      // Loop through groupCheck to find the correct group by matching Lookup_Code in lookupMasterData
      for (const groupKey in groupCheck) {
        const moduleCode = groupCheck[groupKey]?.Module;
        const moduleLookup = allLookups.find(
          (lookup) => lookup.Lookup_Code === moduleCode
        );

        const matchedDetail = moduleLookup?.LookUp_Detail.find(
          (detail) => detail.Lookup_Detail_Code === searchData.searchModule
        );

        if (matchedDetail) {
          moduleDisplayName = matchedDetail.Lookup_Detail_Name;
          break; // Stop looping once found
        }
      }

      if (moduleDisplayName) {
        chips.push(`Module: ${moduleDisplayName}`);
      }
    }

    setChipValue(chips);
  };

  const parseAndFormatDate = (dateString) => {
    const parts = dateString.split("/");
    let year = parts[2];
    if (year.length === 2) {
      const currentYear = new Date().getFullYear().toString();
      const currentCentury = currentYear.slice(0, 2);
      year = `${currentCentury}${year}`;
    }
    const month = parts[1].padStart(2, "0");
    const day = parts[0].padStart(2, "0");
    return `${year}-${day}-${month}`;
  };

  const getLookupDetailCode = (type, label) => {
    const modulePrefix =
      type === "Module" ? "Module_" : type === "API Type" ? "APIType_" : "";

    const lookupGroup = props?.roles?.lookupMasterData?.data?.find((item) =>
      item?.Lookup_Code?.startsWith(modulePrefix));

    const detail = lookupGroup?.LookUp_Detail?.find(
      (d) => d.Lookup_Detail_Name === label
    );

    return detail?.Lookup_Detail_Code || "";
  };

  const handleDeleteChip = (chipToDelete) => {
    // Update the chip list
    const updatedChips = chipValue.filter((chip) => chip !== chipToDelete);
    setChipValue(updatedChips);

    const profileCode = menu?.Role_Permission_Data?.Profile_Code;

    // Prepare the initial form data with default values
    const updatedFormData = {
      Profile_Code: profileCode,
      pageNo: page,
      groupName: idFromUrl,
      pageSize: updatedChips.length > 0 ? rowsPerPage : 5,
      sortColumn: orderBy,
      sortOrder: order,
      exportToExcel: false,
      exportToPDF: false,
      searchRequestedFor: "",
      searchApiType: "",
      searchModule: "",
      searchStatus: "",
      searchStartDate: startDate,
      searchEndDate: endDate,
      searchModuleValue: "",
      searchApiTypeValue: "",
    };

    // Process the selected chips to update search data
    if (updatedChips.length > 0) {
      updatedChips.forEach((chip) => {
        const [key, value] = chip.split(":").map((item) => item.trim());

        // Declare variables outside the switch case to avoid lexical declaration errors
        let apiTypeCode;
        let moduleCode;
        let formattedDate;
        let formattedStartDate;
        let formattedEndDate;
        let sdate;
        let edate;

        switch (key) {
          case "Requested For":
            updatedFormData.searchRequestedFor = value;
            break;
          case "API Type":
            apiTypeCode = getLookupDetailCode("API Type", value);
            updatedFormData.searchApiType = apiTypeCode || "";
            updatedFormData.searchApiTypeValue = value;
            break;
          case "Module":
            moduleCode = getLookupDetailCode("Module", value);
            updatedFormData.searchModule = moduleCode || "";
            updatedFormData.searchModuleValue = value;
            break;
          case "Status":
            updatedFormData.searchStatus = value;
            break;
          case "Date":
            formattedDate = parseAndFormatDate(value);
            updatedFormData.searchStartDate = formattedDate;
            updatedFormData.dateRange = false;
            break;
          case "Date From":
            sdate = value === "Start" ? value : value.split(" - To ")[0].trim();
            edate = value === "End" ? value : value.split(" - To ")[1].trim();
            formattedStartDate =
              sdate === "Start" ? "" : parseAndFormatDate(sdate);
            formattedEndDate = edate === "End" ? "" : parseAndFormatDate(edate);
            updatedFormData.dateRange = true;
            updatedFormData.searchStartDate = formattedStartDate;
            updatedFormData.searchEndDate = formattedEndDate;
            break;
          default:
            break;
        }
      });
    }

    // Set the updated form data and trigger API call
    localStorage.setItem(`filtered_search_${idFromUrl}`, JSON.stringify(updatedFormData))
    setSearchDataFiled(updatedFormData);
    props.clearFormDataApiLogs();
    props.setFormDataApiLogs(updatedFormData);
    props.getApiLogsDataFetchLogs(updatedFormData);
  };

  rows = [];
  const result = props.apiLogsDataFetchLogs.apiLogsDataFetchLogs?.data?.map(
    (items) => ({
      _id: items.requestId,
      Type: items?.Type_Name,
      Module_Name: items?.Module_Name,
      Source: items?.Source,
      Request_Time: items?.Request_Time,
      Response_Time: items?.Response_Time,
      Requested_By: items?.Requested_By?.UID,
      Requested_For: items?.Requested_For?.UID,
      Requested_By_Name: items?.Requested_By?.Name,
      Requested_For_Name: items?.Requested_For?.Name,
      Request_JSON: items?.Request_JSON,
      Response_JSON: items?.Response_JSON,
      Status: items?.Status,
      Requested_By_Vik: items?.Requested_By,
      Requested_For_Vik: items?.Requested_For,
    })
  );
  if (result) {
    result.forEach((v) => {
      const _id = v._id;
      const Type = v.Type;
      const Module_Name = v.Module_Name;
      const Source = v.Source;
      const Request_Time = moment(v.Request_Time)
        .tz("America/New_York")
        .format("MM/DD/YYYY hh:mm A");
      const Response_Time = v.Response_Time
        ? moment(v.Response_Time)
          .tz("America/New_York")
          .format("MM/DD/YYYY hh:mm A")
        : "";
      const Requested_By = `${v.Requested_By_Name || v.Requested_By_Vik || "NA"}`;
      const Requested_For = `${v.Requested_For || v.Requested_For_Vik || "NA"}`;
      const Request_JSON = v.Request_JSON;
      const Response_JSON = v.Response_JSON;
      const Status = v.Status;
      rows.push(
        createData(
          _id,
          Type,
          Module_Name,
          Source,
          Request_Time,
          Response_Time,
          Requested_By,
          Requested_For,
          Request_JSON,
          Response_JSON,
          Status
        )
      );
    });
  }

  const handleUpdateDBAModal = (data) => {
    if (encryptionKey == "NO") {
      const parsedData = data?.data
      setRequestJsonData(parsedData?.Request_JSON);
      setResponseJsonData(parsedData?.Response_JSON);
      setRequestReferenceId(parsedData?.Request_JSON?.Header?.RequestReferenceId);
      setUpdateDBAModal(true);
    } else {
      const bytes = CryptoJS.AES.decrypt(data?.data, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      const parsedData = JSON.parse(decryptedData);
      setRequestJsonData(parsedData?.Request_JSON);
      setResponseJsonData(parsedData?.Response_JSON);
      setRequestReferenceId(parsedData?.Request_JSON?.Header?.RequestReferenceId);
      setUpdateDBAModal(true);
    }

  };

  const showMaskedData = () => {
    if (showDecData) {
      return setShowDecData(false)
    }
    if (requestJsonDataNew !== null) {
      // setRequestJsonData(requestJsonDataNew);
      return setShowDecData(true)
    } else {
      const payload = {
        RequestReferenceId: requestReferenceId,
      };
      props.getDecryptedApiLogsJsonDataACH(payload, (data) => {
        setLoading(false);

        const apiData =
          encryptionKey === "NO"
            ? data.data
            : JSON.parse(
              CryptoJS.AES.decrypt(data.data, secretKey).toString(
                CryptoJS.enc.Utf8,
              ),
            );
        if (apiData.SingleTransactionDetail !== undefined) {
          const updatedData = {
            ...requestJsonData,
            SingleTransactionDetail: {
              ...requestJsonData.SingleTransactionDetail,
              RoutingNumber: apiData.SingleTransactionDetail.RoutingNumber,
              BankAccountNumber:
                apiData.SingleTransactionDetail.BankAccountNumber,
              Ssn: apiData.SingleTransactionDetail.SSN,
            },
          };
          // setRequestJsonData(updatedData);
          setRequestJsonDataNew(updatedData);
          setShowDecData(true)
        } else if (apiData.TransactionDetails !== undefined) {
          const updatedData = {
            ...requestJsonData,
            TransactionDetails: requestJsonData.TransactionDetails.map(
              (transaction) => {
                const updatedTransaction = apiData.TransactionDetails.find(
                  (item) =>
                    item.RequestTxnReferenceId ===
                    transaction.RequestTxnReferenceId,
                );

                if (!updatedTransaction) {
                  return transaction;
                }

                return {
                  ...transaction,
                  RoutingNumber: updatedTransaction.RoutingNumber,
                  BankAccountNumber: updatedTransaction.BankAccountNumber,
                  Ssn: updatedTransaction.SSN,
                };
              },
            ),
          };

          // setRequestJsonData(updatedData);
          setRequestJsonDataNew(updatedData);
          setShowDecData(true)
        }
      });
    }
  };
  const requestJsonContent = React.useMemo(() => {
    return (
      <SyntaxHighlighter language="json" style={codeStyle}>
        {JSON.stringify(
          showDecData ? requestJsonDataNew : requestJsonData,
          null,
          2
        )}
      </SyntaxHighlighter>
    );
  }, [showDecData, requestJsonDataNew, requestJsonData]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);

    const requestData = {
      Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
      pageSize: rowsPerPage,
      sortColumn: property,
      sortOrder: newOrder,
      pageNo: page,
      groupName: idFromUrl,
      exportToExcel: false,
      exportToPDF: false,
      searchRequestedFor: searchDataFiled?.searchRequestedFor ?? props?.apiLogsDataFetchLogs?.searchRequestedFor ?? "",
      searchStartDate: searchDataFiled?.searchStartDate ?? startDate ?? "",
      searchEndDate: searchDataFiled?.searchEndDate ?? endDate ?? "",
      searchApiType: searchDataFiled?.searchApiType ?? props?.apiLogsDataFetchLogs?.searchApiType ?? "",
      searchModule: searchDataFiled?.searchModule ?? props?.apiLogsDataFetchLogs?.searchModule ?? "",
      searchStatus: searchDataFiled?.searchStatus ?? props?.apiLogsDataFetchLogs?.searchStatus ?? "",
      // dateRange: props?.apiLogsDataFetchLogs?.dateRange,
    };
    props.getApiLogsDataFetchLogs(requestData);
  };

  const handleSearchOpen = () => {
    setSearchBar(true);
  };

  const handleSearchClose = () => {
    setSearchBar(false);
  };

  const handleRefresh = (refresh = false) => {
    setUpdateDBAModal(false);
    setOrder("desc");
    setOrderBy("Request_Time");
    setPage(0);
    setRowsPerPage(5);

    const searchData = localStorage.getItem(
      `filtered_search_${idFromUrl}`,
    );
    if (searchData) {
      const existingData = JSON.parse(searchData);
      const data = {
        ...existingData,
        forceRefresh: refresh,
      };
      props.getApiLogsDataFetchLogs(data);
    } else {
      const payload = {
        Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
        pageSize: 5,
        sortColumn: "Request_Time",
        sortOrder: "desc",
        pageNo: 1,
        forceRefresh: true,
        groupName: idFromUrl,
        exportToExcel: false,
        exportToPDF: false,
        searchRequestedFor:
          searchDataFiled?.searchRequestedFor ??
          props?.apiLogsDataFetchLogs?.searchRequestedFor ??
          "",
        searchStartDate:
          searchDataFiled?.searchStartDate ??
          startDate ??
          "",
        searchEndDate:
          searchDataFiled?.searchEndDate ??
          endDate ??
          "",
        searchApiType:
          searchDataFiled?.searchApiType ??
          props?.apiLogsDataFetchLogs?.searchApiType ??
          "",
        searchModule:
          searchDataFiled?.searchModule ??
          props?.apiLogsDataFetchLogs?.searchModule ??
          "",
        searchStatus:
          searchDataFiled?.searchStatus ??
          props?.apiLogsDataFetchLogs?.searchStatus ??
          "",
        // dateRange: props?.apiLogsDataFetchLogs?.dateRange,
      };

      props.getApiLogsDataFetchLogs(payload);
    }
  };

  const handleClearChips = () => {
    const chips = [];
    const formattedStartDate = format(parseISO(startDate), "MM/dd/yy");
    const formattedEndDate = format(parseISO(endDate), "MM/dd/yy");
    chips.push(`Date From: ${formattedStartDate} - To ${formattedEndDate}`);
    setChipValue(chips);
    const updatedFormData = {
      pageNo: 1,
      pageSize: 5,
      searchRequestedFor: "",
      searchApiType: "",
      searchApiTypeValue: "",
      searchModule: "",
      searchModuleValue: "",
      groupName: idFromUrl,
      searchStatus: null,
      searchStartDate: startDate,
      searchEndDate: endDate,
      dateRange: true,
    };
    setSearchDataFiled(updatedFormData);
    props.setFormDataApiLogs(updatedFormData);
    localStorage.setItem(`filtered_search_${idFromUrl}`, JSON.stringify(updatedFormData))
  };

  const handleApplyFilter = (data) => {
    localStorage.setItem(`filtered_search_${idFromUrl}`, JSON.stringify(data))
    setSearchDataFiled(data);
    displayAndDeleteChips(data);
  }

  return (
    <>
      <AppLoader loader={loading} />
      <TableContainer className={classes.TableContainer} component={Paper}>
        <Modal
          open={updateDBAModal}
          onClose={onClose}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-labelledby="sasdasd"
          aria-describedby="simpleasdasdasdan"
        >
          <Zoom
            in={updateDBAModal}
            style={{ transitionDelay: updateDBAModal ? "250ms" : "0ms" }}
          >
            <Fade in={updateDBAModal}>
              <Paper
                className={classes.dialogBoxBorder}
                style={{
                  width: "910px",
                }}
              >
                <div className={classes.statusModalHeader}>
                  <div className={classes.statusHeadingText}>JSON Data</div>
                  <ClearIcon
                    style={{ color: "white", cursor: "pointer" }}
                    onClick={() => onClose(false)}
                  />
                </div>

                <Grid container className={classes.margin}>
                  <Grid item xl={6} xs={6} md={6} lg={6}>
                    <Box
                      style={{
                        paddingLeft: "10px",
                        fontWeight: "bold",
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Request JSON
                      </Typography>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {apiType && (
                          <Typography>
                            <Tooltip
                              title={
                                showDecData
                                  ? "Hide Unmasked Data"
                                  : "Show Unmasked Data"
                              }
                              arrow
                            >
                              <IconButton onClick={showMaskedData}>
                                {showDecData ? (
                                  <VisibilityOffIcon />
                                ) : (
                                  <VisibilityIcon />
                                )}
                              </IconButton>
                            </Tooltip>
                          </Typography>
                        )}

                        <Typography>
                          {" "}
                          <IconButton onClick={copyToClipboardRequest}>
                            <FileCopyIcon />
                          </IconButton>
                        </Typography>
                      </span>

                    </Box>

                    <DialogContent
                      style={{
                        height: "600px",
                      }}
                    >
                      <div className="code-editor">
                        {requestJsonContent}
                      </div>
                    </DialogContent>
                  </Grid>

                  <Grid item xl={6} xs={6} md={6} lg={6}>
                    <Box
                      style={{
                        paddingLeft: "10px",
                        fontWeight: "bold",
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                        borderLeft: "1px solid #707070",
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Response JSON
                      </Typography>

                      <Typography>
                        {" "}
                        <IconButton onClick={copyToClipboardResponse}>
                          <FileCopyIcon />
                        </IconButton>
                      </Typography>
                    </Box>
                    <DialogContent
                      style={{
                        height: "600px",
                        borderLeft: "1px solid #707070",
                      }}
                    >
                      <div className="code-editor">
                        <SyntaxHighlighter language="json" style={codeStyle}>
                          {JSON.stringify(responseJsonData, null, 2)}
                        </SyntaxHighlighter>
                      </div>
                    </DialogContent>
                  </Grid>
                </Grid>
              </Paper>
            </Fade>
          </Zoom>
        </Modal>
        {windowWidth && (
          <Grid container className={classes.searchContainer}>
            <Grid item className={classes.margin}>
              <div className={classes.searchWrapper}>
                <SearchFields
                  searchBar={searchBar}
                  handleSearchClose={handleSearchClose}
                  handleSearchOpen={handleSearchOpen}
                  Fields={() => (
                    <ApiLogsSearchNew
                      close={() => handleSearchClose()}
                      seacrhChipData={(data) => 
                        handleApplyFilter(data)
                      }
                      clearChips={() => {
                        handleClearChips()
                      }}
                      order={order}
                      orderBy={orderBy}
                    />
                  )}
                />
                <IconsTooltip title="Refresh" placement="top">
                  <div className={classes.appSvgIcons}>
                    <SyncIcon
                      style={{ marginRight: "10px" }}
                      fontSize="large"
                      color="primary"
                      onClick={()=> handleRefresh(true)}
                    />
                  </div>
                </IconsTooltip>
                <IconsTooltip title="Export" placement="top">
                  <div className={classes.appSvgIcons}>
                    <ExportIcon
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleToggle}
                      ref={anchorRef}
                    />
                  </div>
                </IconsTooltip>
                <Popper
                  open={openImportFileModal}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  placement="bottom-start"
                  transition
                  disablePortal
                  style={{
                    zIndex: "10",
                  }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom-start"
                            ? "left top"
                            : "left bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleCloseModel}>
                          <MenuList
                            id="menu-list-grow"
                            onKeyDown={handleListKeyDown}
                          >
                            {actionPermission(
                              permissionCheck.Category.setup,
                              permissionCheck.Page.merchant,
                              permissionCheck.option.exportToExcel,
                            ) && (
                                <MenuItem
                                  onClick={exportListData}
                                  style={{
                                    fontSize: "14px",
                                  }}
                                >
                                  Export to Excel
                                </MenuItem>
                              )}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </Grid>
          </Grid>
        )}
        {!windowWidth && (
          <Grid container className={classes.searchContainer}>
            <Grid item className={classes.margin} style={{ display: "flex" }}>
              <div className={classes.searchWrapper}>
                <SearchFields
                  searchBar={searchBar}
                  handleSearchClose={handleSearchClose}
                  handleSearchOpen={handleSearchOpen}
                  Fields={() => (
                    <ApiLogsSearchNew
                      close={() => handleSearchClose()}
                      seacrhChipData={(data) => 
                        handleApplyFilter(data)
                      }
                      clearChips={() => {
                        handleClearChips()
                      }}
                    />
                  )}
                />

                <IconsTooltip title="Export" placement="top">
                  <div className={classes.appSvgIcons}>
                    <ExportIcon
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleToggle}
                      ref={anchorRef}
                    />
                  </div>
                </IconsTooltip>
                <Popper
                  open={openImportFileModal}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  placement="bottom-start"
                  transition
                  disablePortal
                  style={{
                    zIndex: "10",
                  }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom-start"
                            ? "left top"
                            : "left bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleCloseModel}>
                          <MenuList
                            id="menu-list-grow"
                            onKeyDown={handleListKeyDown}
                          >
                            {actionPermission(
                              permissionCheck.Category.setup,
                              permissionCheck.Page.merchant,
                              permissionCheck.option.exportToExcel,
                            ) && (
                                <MenuItem
                                  style={{
                                    fontSize: "14px",
                                  }}
                                >
                                  Export to Excel
                                </MenuItem>
                              )}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </Grid>
          </Grid>
        )}
        <SearchChips
          searchValues={chipValue}
          handleDeleteChip={(chip, index) => handleDeleteChip(chip, index)}
        />
        <Table className={classes.table} aria-label="simple table">
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {!isEmpty(rows) ? (
              rows.map((row, index) => (
                <TableRow className={classes.cellHeadSign} key={index}>
                  <TableCell className={classes.cellText}>{row.Type}</TableCell>
                  {/* <TableCell className={classes.cellText} align="left">
                    {row.Module_Name}
                  </TableCell> */}
                  {/* <TableCell className={classes.cellText} align="left">
                    {row.Source}
                  </TableCell> */}
                  <TableCell className={classes.cellText} align="left">
                    {row.Request_Time}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Response_Time}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Requested_By}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Requested_For}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Status}
                  </TableCell>
                  <TableCell className={classes.cellText}>
                    <LongMenu
                      handleUpdateDBAModal={() => {
                        const menu = localStorage.getItem("menu");
                        let allowDecryption = false;
                        try {
                          allowDecryption = menu ? JSON.parse(menu)?.AllowDecryption ?? false : false;
                        } catch (error) {
                          console.error("Invalid menu data in localStorage:", error);
                        }
                        if (idFromUrl == "ACH" && row.Status !== "Failure") {
                          if (
                            allowDecryption &&
                            (row.Type == "Batch Transaction" ||
                              row.Type == "Single Transaction")
                          ) {
                            setApiType(true);
                          } else {
                            setApiType(false);
                          }
                        }

                        // const payload =   ;
                        setLoading(true);
                        props.getApiLogsByIdDataFetchLogsNew(
                          { requestId: row._id, groupName: idFromUrl },
                          (data) => {
                            setLoading(false);
                            if (data) {
                              handleUpdateDBAModal(data);
                            }
                          },
                        );
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell className="no-data" colSpan={12}>
                  <img
                    src={noDataImage}
                    alt=""
                    className={classes.noDataImage}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {rows.length ? (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    {
                      label: "All",
                      value:
                        props.apiLogsDataFetchLogs?.apiLogsDataFetchLogs
                          ?.pagination?.totalRecordsAvailable,
                    },
                  ]}
                  colSpan={12}
                  count={
                    props.apiLogsDataFetchLogs?.apiLogsDataFetchLogs?.pagination
                      ?.totalRecordsAvailable
                  }
                  rowsPerPage={rowsPerPage || 5}
                  page={page > 0 ? page - 1 : 0}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    MenuProps: { classes: { paper: classes.selectDropdown } },
                  }}
                  classes={{ menuItem: classes.menuItem }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          ) : (
            ""
          )}
        </Table>
      </TableContainer>
    </>
  );
};

ProviderReport.propTypes = {
  tableData: PropTypes.object,
  history: PropTypes.any,
  userDetails: PropTypes.object,
  mainData: PropTypes.object,
  getMerchantListData: PropTypes.func,
  getApiLogsDataFetchLogs: PropTypes.func,
  getApiLogsByIdDataFetchLogs: PropTypes.func,
  getApiLogsDataExportNew: PropTypes.func,
  getApiLogsDataJson: PropTypes.func,
  getManagerListDataByID: PropTypes.func,
  sendInviteApiCall: PropTypes.func,
  emptyReduxState: PropTypes.func,
  sendInviteManagerApiCall: PropTypes.func,
};

const mapStateToProps = (app) => ({
  tableData: app.provideRegistration,
  userDetails: app.app,
  mainData: app,
  roles: app.roles,
  merchantListData: app.merchantInformation,
  apiLogsDataFetchLogs: app.merchantInformation,
  managerListData: app.merchantInformation,
  managerListDataById: app.merchantInformation,
});
export default connect(mapStateToProps, {
  getApiLogsDataFetchLogs,
  getApiLogsByIdDataFetchLogs,
  getApiLogsByIdDataFetchLogsNew,
  getApiLogsDataExportNew,
  getApiLogsDataJson,
  sendInviteApiCall,
  emptyReduxState,
  sendInviteManagerApiCall,
  getDecryptedApiLogsJsonDataACH,
  setFormDataApiLogs,
  clearFormDataApiLogs,
})(ProviderReport);
